module.exports = __webpack_public_path__ + "media/universities/MINES-a91dec67.png";